import { formatNumberWithCommas } from 'src/app/shared/utils'
import { creaditOrDebitOptions } from '../add-ach-modal/constant'
import { MAPPING_PROPS, SEC_CODE_PROPS } from '../constants/index.model'

export const getMappingInfo = (input: string, mappingCode: MAPPING_PROPS) => {
  const inputList = input?.split(',')
  if (inputList?.length === 1) {
    return mappingCode[inputList[0]]
  }

  const inputMappingList = inputList.map((inputItem: string) => mappingCode[inputItem.trim()])
  return inputMappingList?.join(', ')
}

export const getCreditDebitCode = (creditDebitValue: string) => {
  return creaditOrDebitOptions.find((option: any) => option?.label === creditDebitValue)?.value
}

export const getNewListSecCode = (currentList: string[], inputSecCode: string[], listSecCode: SEC_CODE_PROPS[]) => {
  return currentList?.map((item: string) => {
    if (inputSecCode?.includes(item)) {
      const updateSecCode = listSecCode?.find((secCode: SEC_CODE_PROPS) => secCode?.label === item)
      return updateSecCode?.value
    }

    return item
  })
}

export const formatAmountValue = (amount: string) => {
  if (!amount) {
    return 0;
  }
  const amountNumber = Number(amount.toString().replace(/[$,]/g, ""));
  return formatNumberWithCommas(amountNumber);
}
